import * as yup from "yup";

const pmsUpdateSchema = yup.object({
  _id: yup.string(),
  pmsName: yup.string().required("Please Enter PMS Name"),
  pms_name: yup.string().required("Please Enter PMS Name"),
  pms_version: yup.string(),
});

export default pmsUpdateSchema;
